module.exports = __webpack_public_path__ + "star-circle-outline.31VxEP5y.svg";